import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';

/*  eslint-disable jsx-a11y/no-noninteractive-tabindex */
export class Toggle extends React.PureComponent {
  static propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    checked: false,
    className: 'toggle',
    label: 'toggle',
    disabled: false,
    id: null,
    name: null,
  }

  constructor(props) {
    super(props);
    this.props = props;
    this.state = { isChecked: props.checked };
  }

  // if checked updated externally, update the state
  componentDidUpdate(prevProps) {
    if (this.props.checked !== prevProps.checked
      || this.props.checked !== this.state.isChecked) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isChecked: this.props.checked });
    }
  }

  onInputChange = ({ target: { checked } }) => this.props.onChange(checked);

  onChange = () => {
    this.setState(
      state => ({ isChecked: !state.isChecked }),
      () => this.props.onChange(this.state.isChecked)
    );
  }

  render() {
    const {
      name, disabled, className, label,
    } = this.props;
    const { id = _.uniqueId('toggle-') } = this.props;
    return (
      <label className={classnames('switch', className)} htmlFor={id}>
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={this.state.isChecked}
          disabled={disabled}
          onChange={this.onInputChange}
        />
        <span
          className="slider round"
          tabIndex="0"
          role="switch"
          aria-checked={this.state.isChecked}
          aria-label={label}
          onKeyDown={event => submitEvent(this.onChange)(event, event)}
        />
      </label>
    );
  }
}
